import * as SC from 'styled-components'

export type Color = 'blue' | 'darkBlue' | 'green' | 'gray' | 'darkGray' | 'lightGray' | 'bluishGray' | 'lightBluishGray' | 'red' | 'white' | 'transparent' | 'black' | 'placeholder'
export type FontSize = 'hint' | 'regular' | 'title' | 'largerTitle'

export interface IptuTheme {
  color: {
    [key in Color]: string
  }

  fontSize: {
    [key in FontSize]: string
  }

  forms: {
    fields: {
      color: string
      border: string
      background: string
      placeholderFormStyle: 'normal' | 'italic'
    }
    label: string
    error: string
    button: {
      color: string
      border: string
      background: string
    }
  }

  mediaQueries: {
    menu: string
    modal: string
    home: string
    form: string
    layout: string
    layoutMobile: string
  }

  zIndex: {
    header: number
    backdrop: number
    backdropContent: number
  }
}

export const theme: IptuTheme = {
  color: {
    blue: '#29B6F6',
    darkBlue: '#01579B',

    green: '#9CCC65',

    gray: '#606060',
    lightGray: '#E0e0e0',
    darkGray: '#757575',
    bluishGray: '#80ABCD',
    lightBluishGray: '#C7D7E2',

    placeholder: '#c7c7c7',

    red: '#ED5D64',

    white: '#FFFFFF',

    transparent: 'rgba(255, 255, 255, 0)',

    black: '#222222',
  },

  fontSize: {
    hint: '12px',
    regular: '16px',
    title: '20px',
    largerTitle: '36px',
  },

  forms: {
    fields: {
      color: '#848484',
      border: '#848484',
      background: '#ffffff',
      placeholderFormStyle: 'italic',
    },
    label: '#606060',
    error: '#ff0000',
    button: {
      color: '#ffffff',
      border: '#848484',
      background: '#848484',
    },
  },

  mediaQueries: {
    menu: '700px',
    modal: '800px',
    form: '600px',
    home: '800px',
    layout: '1000px',
    layoutMobile: '90vw',
  },

  zIndex: {
    header: 999,
    backdrop: 1000,
    backdropContent: 1001,
  },
}

export const adminTheme: IptuTheme = {
  color: {
    blue: '#29B6F6',
    darkBlue: '#01579B',

    green: '#9CCC65',

    gray: '#9a9a9a',
    lightGray: 'rgb(237, 242, 249)',
    darkGray: '#757575',
    bluishGray: '#80ABCD',
    lightBluishGray: '#C7D7E2',

    placeholder: '#b8c3d5',

    red: '#ED5D64',

    white: '#FFFFFF',

    transparent: 'rgba(255, 255, 255, 0)',

    black: '#222222',
  },

  fontSize: {
    hint: '12px',
    regular: '16px',
    title: '20px',
    largerTitle: '36px',
  },

  forms: {
    fields: {
      color: '#848484',
      border: '#848484',
      background: '#ffffff',
      placeholderFormStyle: 'normal'
    },
    label: '#606060',
    error: '#ff0000',
    button: {
      color: '#ffffff',
      border: '#848484',
      background: '#848484',
    },
  },

  mediaQueries: {
    menu: '700px',
    modal: '800px',
    form: '600px',
    home: '800px',
    layout: '1000px',
    layoutMobile: '90vw',
  },

  zIndex: {
    header: 999,
    backdrop: 1000,
    backdropContent: 1001,
  },
}

const {
  default: styled,
  css,
  ThemeProvider,
  ThemeConsumer,
} = SC as SC.ThemedStyledComponentsModule<IptuTheme>

export {
  css,
  ThemeProvider,
  ThemeConsumer,
}
export default styled
